import React, { Component } from "react";
import {  Input, Table } from "antd";
// import { connect } from "react-redux";
// import moment from "moment";
import Api from "../../services/ServiceApi";
import AddCheckList from "./data/add_check_list";
// import { LeftOutlined } from "@ant-design/icons";
// import Cookies from "js-cookie";
import ChangePath from "../../services/ServiceApi";
const columns = [
  {
    title: "Check List ID",
    dataIndex: "job_checklist_group_id",
    key: "job_checklist_group_id",
    align: "center",
    sorter: (a, b) => null,
  },
  {
    title: "Check List Name",
    dataIndex: "job_checklist_group_name",
    key: "job_checklist_group_name",
    sorter: (a, b) => null,
  },
  {
    title: "Department",
    dataIndex: "",
    sorter: (a, b) => null,
    key: "",
    render: (item) => <div>{"-"}</div>,
  },
  {
    title: "Job Category",
    dataIndex: "",
    key: "",
    sorter: (a, b) => null,
  },
  {
    title: "Job Type",
    dataIndex: "",
    key: "",
    sorter: (a, b) => null,
  },
  {
    title: "Job Sub Type",
    dataIndex: "",
    key: "",
    sorter: (a, b) => null,
  },
  {
    title: "Status",
    dataIndex: "is_active",
    align: "center",
    key: "is_active",
    sorter: (a, b) => null,
  },
  {
    title: "Action",
    dataIndex: "",
    key: "",
    sorter: (a, b) => null,
    render: (item) => (
      <>
        <a
          className="font-thai-sb fs-18 text-underlinem ml-3"
          style={{ color: "#6864FF" }}
          // onClick={() => this.Adddescription(item)}
          onClick={() => this.editCheckList()}
        >
          <img
            style={{
              float: "center",
              marginLeft: "-15px",
            }}
            src={Api.absoluteUrl("/icon/icon_edit.svg")}
          />
        </a>
        <a
          className="font-thai-sb fs-18 text-underline ml-4"
          style={{ color: "#6864FF" }}
          // onClick={() => this.onDelete(item)}
        >
          <img
            style={{
              float: "center",
              marginLeft: "-15px",
            }}
            src={Api.absoluteUrl("/icon/delete_colum.svg")}
          />
        </a>
      </>
    ),
  },
];

class Checklist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: 0,
      menu: [
        { icon: "ma_list.svg", title: "MA List", link: "" },
        {
          icon: "ma_team_service.svg",
          title: "MA Team Service",
          link: "/ma_team_service",
        },
        { icon: "", title: "Material Stock", link: "/material_stock" },
        {
          icon: "notifications.svg",
          title: "Notifications",
          link: "/notifications",
        },
        { icon: "report.svg", title: "Report", link: "/report" },
        { icon: "", title: "Setting", link: "/setting" },
      ],
      visible: false,
      value: 1,
      title: "Job Skill",
      data: [],
      status_display: false,
    };
  }

  async componentDidMount() {
    document.title = this.state.title;
    //console.log('job skill company : '+Cookies.get("companyid"));
    const grouplist = await Api.post("get_jobchecklist_group_all", {
      // pk_id: null,
      // is_active: 1,
      // effective: null,
      // sql_where: null,
      // company_id: Cookies.get("companyid"),
      group_name: "ALL",
    });
    this.setState({
      data: grouplist.data.data,
    });
  }

  handleSubmit(values) {
    values.create_by = 3;
    values.effective_date = "2020-05-15";
    values.expire_date = "2020-06-15";

    this.props.submit(values);
  }
  onChange = (e) => {
    this.setState({ value: e.target.value });
  };
  onModal(mode, visible) {
    this.setState({
      mode: mode,
      visible: visible,
    });
  }

  // renderAddCheckListGroup = () =>{
  //   return
  //   ()
  // }
  render() {
    const { title, data } = this.state;
    return (
      <div>
        {this.state.status_display === true ? (
          <>
            <a
              className="font-thai-sb fs-20 text-underlinem "
              onClick={() => this.setState({status_display : false})}
            >
              <i class="fas fa-chevron-left" style={{ fontSize: "13px" }} />
              <span> Back </span>
            </a>
            <AddCheckList />
          </>
        ) : (
          <>
            <span className="font-mont-r fs-12">Basic Data</span>
            <h3 className="font-mont-sb fs-18 c-blue mt-2">Check List</h3>

            <div className="d-flex justify-content-between my-3">
              <Input.Search
                placeholder="Search"
                onSearch={(value) => console.log(value)}
                style={{ width: 200 }}
              />

              <button
                className="btn btn-warning"
                onClick={() =>  this.setState({status_display : true})}
              >
                <img src={ChangePath.absoluteUrl("/icon/plus.svg")} className="mr-2" />
                Add Check List
              </button>
            </div>
            <Table columns={columns} dataSource={data} pagination={false} />
          </>
        )}
      </div>
    );
  }
}

export default Checklist;
